/* eslint-disable react-hooks/exhaustive-deps */
import { ChangeEvent, useEffect, useState } from "react"
import { Form } from "react-bootstrap"

/**
 * CheckInputコンポーネント
 * @param props
 * @param type switch、checkboxで切り替えを想定
 * @returns CheckInputコンポーネント
 */
const CheckInput = (props: {
  type: "checkbox" | "switch"
  id?: string
  label: string
  isDisabled?: boolean
  value: number
  setValue: (v: number) => unknown
  isRequired?: boolean
  onClick?: React.MouseEventHandler<HTMLInputElement>
  //onValueChange: Function
  tabIndex?: number
}) => {
  const [chkFlg, setChkFlg] = useState<boolean>(false)

  // 外からsetValueされた場合はChkFlgを同期させる
  useEffect(() => {
    if (props.value === 0 && !chkFlg) return
    if (props.value === 1 && chkFlg) return

    // 異なる場合はvalueとchkFlgを同期する
    setChkFlg(props.value ? true : false)
  }, [props.value])

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        marginLeft: ".8rem",
      }}>
      <Form.Check
        className={props.type === "switch" ? "custom-switch-md" : undefined}
        type={props.type}
        id={props.id}
        label={props.label}
        onClick={props.onClick}
        disabled={props.isDisabled}
        value={props.value}
        required={props.isRequired}
        checked={chkFlg}
        tabIndex={props.tabIndex}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setChkFlg(e.target.checked)
          props.setValue(e.target.checked ? 1 : 0)
        }}></Form.Check>
    </div>
  )
}

export default CheckInput
